import enumerate from 'lib/enumerate';

export const ActionTypes = enumerate([
  'LOAD_USER',
  'USER_UPDATED',
  'USER_DELETED',
  'USER_CONFIRMED',
  'PREFERENCES_UPDATED',
]);

export const Roles = {
  TEACHER: 'teacher',
  teacher: 'teacher',
  STUDENT: 'student',
  student: 'student',
  PARENT: 'parent',
  parent: 'parent',
  ADMIN: 'admin',
};

export const MERGING_USER_PATH = '/merging_user';
